"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_jss_1 = require("react-jss");
const MultiPlayerGuestForm_1 = __importDefault(require("./components/MultiPlayerGuestForm"));
const MultiPlayerHostForm_1 = __importDefault(require("./components/MultiPlayerHostForm"));
const ArrowBack_1 = __importDefault(require("./components/ArrowBack"));
exports.useStyles = (0, react_jss_1.createUseStyles)({
    form: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "20px 0",
    },
    input: {
        width: "80%",
        marginTop: 0,
    },
    button: {
        padding: "12px 60px",
    },
    root: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
    },
    logo: {
        width: "100%",
        margin: "20px 0",
    },
    wrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        width: 500,
        maxWidth: "100%",
        margin: 0,
        padding: 20,
        background: "#ECECEC",
        borderRadius: 5,
        boxShadow: "0px 1px 2px #0006",
    },
    separator: {
        fontFamily: '"Bubblegum Sans", cursive',
        fontSize: 18,
        color: "#555",
        textAlign: "center",
    },
});
const MultiPlayerPage = () => {
    const classes = (0, exports.useStyles)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [state, setState] = (0, react_1.useState)({
        nickname: "",
        code: "",
    });
    const handleGameStart = ({ nickname, code, player, }) => {
        navigate({
            pathname: "/game/",
            search: `?code=${code}&player=${player}&nickname=${nickname}`,
        });
    };
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(ArrowBack_1.default, null),
        react_1.default.createElement("div", { className: classes.wrapper },
            react_1.default.createElement("img", { src: require("!file-loader!../svg/logo.svg").default, className: classes.logo }),
            react_1.default.createElement(MultiPlayerHostForm_1.default, { onGameStart: handleGameStart }),
            react_1.default.createElement("div", { className: classes.separator }, "\u2014 OR \u2014"),
            react_1.default.createElement(MultiPlayerGuestForm_1.default, { onGameStart: handleGameStart }))));
};
exports.default = MultiPlayerPage;
